<template>
  <a-card>
    <h2>Upload CSS File</h2>
    <div class="button-wrap">
        <p>
            Browse and upload a css file from your file system.
        </p>
        <div class="upload-wrap">
            <a-button
                v-if="file"
                class="button"
                icon="upload"
                style="width: auto; border: 1px solid #D9D9D9; margin-right: 10px;"
                @click="onFileUpload"
            >
                Upload File
            </a-button>
            <a-upload
                :fileList="fileList"
                @change="onFileSelect"
            >
                <a-button
                    class="button"
                    ghost
                    style="color: #262626; border: 1px solid #D9D9D9;"
                >
                    Browse File
                </a-button>
            </a-upload>
        </div>
    </div>
  </a-card>
</template>

<script>
export default {
  data() {
    return {
      file: null,
      fileList: [],
    };
  },
  methods: {
    emitUploadFile () {
        this.$emit('file-upload', this.file);
    },
    onFileUpload () {
        this.emitUploadFile();
        this.fileList = [];
        this.file = null;
    },
    onFileSelect (info) {
        // info obj provides hooks where we can handle statuses (more clarification on ant design docs page)
        // e.g. info.file.status === 'done' { *do something* }
        // e.g. info.file.status === 'error' { *handle error* }
        // NOTE: Ant upload seems to work differently for localhost, so we will never have status 'done'

        this.fileList = [info.file]; // this prevents the upload to be multiple
        this.file = info.file.originFileObj;

        if (info.file.status === 'removed') {
            this.fileList = [];
            this.file = null;
        }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  display: flex;
  align-items: center;
  padding: 8px 16px;

  width: 141px;
  height: 40px;

  background: #2295D6;
  border-radius: 2px;
  color: #FFF;
  &.cancel {
    width: auto;
    justify-content: center;
    background: #FFF;
    color: #001529;  
  }
}

.upload-wrap {
    display: flex;
}
</style>